import {
  Avatar,
  Box,
  Button,
  Flex,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconCheckRed from "../../assets/images/iconCheckRed.png";
import iconRejected from "../../assets/images/contract/x-circle.svg";
import { RiResetLeftFill } from "react-icons/ri";
import { MdAutorenew } from "react-icons/md";
import { formatNumber } from "../../utils/utils";
import { useEffect, useState } from "react";

export const EditableCell = ({
  initialValue,
  keyName,
  onSubmit,
  id,
  isInput,
  isInputNoRate,
  isCalculate,
}) => {
  const [rawValue, setRawValue] = useState(initialValue?.toString() || "");

  useEffect(() => {
    setRawValue(initialValue?.toString() || "");
  }, [initialValue]);

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";

    const [intPart, decimalPart] = value.toString().split(".");
    const formattedInt = Number(intPart || "0").toLocaleString("en-US");

    if (value.endsWith?.(".")) return `${formattedInt}.`;
    if (decimalPart !== undefined) return `${formattedInt}.${decimalPart}`;
    return formattedInt;
  };

  const handleChange = (e) => {
    const input = e.target.value;

    // Cho phép nhập số và 1 dấu chấm
    if (!/^\d*\.?\d*$/.test(input.replace(/,/g, ""))) return;

    // Xóa dấu phẩy để lấy raw
    const cleaned = input.replace(/,/g, "");
    setRawValue(cleaned);
  };

  const handleBlur = () => {
    const parsed = Math.round((parseFloat(rawValue) || 0) * 100) / 100;

    // onSubmit("remainingRevenueAfterTax", id, parsed, keyName);

    // Reset lại rawValue để đảm bảo state hợp lệ
    setRawValue(parsed.toString());
  };

  return (
    <Input
      type="text"
      value={formatNumber(rawValue)}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="Nhập số"
    />
  );
};

export const formatTableValue = (
  value,
  key,
  isCalculate,
  submit,
  id,
  statusData,
  code
) => {
  function formatNumber(val) {
    if (val === null || val === undefined || val === "") return "";
    return Number(val).toLocaleString("en-US");
  }

  switch (key) {
    case "mechanismRate":
      return (
        <Input
          step={"any"}
          type="number"
          value={Number(value)}
          placeholder="Nhập số"
          min={0}
          max={100}
          onChange={(e) => {
            const newValueRaw = e.target.value;
            const newValueNumber = Number(newValueRaw);
            submit({
              id,
              key,
              value: newValueNumber,
            });
          }}
        />
      );
    case "rate":
      return (
        <Input
          step={"any"}
          type="number"
          value={Number(value)}
          placeholder="Nhập số"
          onChange={(e) => {
            const newValueRaw = e.target.value;
            const newValueNumber = Number(newValueRaw);
            submit({
              id,
              key,
              value: newValueNumber,
            });
          }}
        />
      );
    case "mechanismRateElite":
      return (
        <Box position={"relative"}>
          <Input
            step={"any"}
            type="number"
            value={Number(value)}
            placeholder="Nhập số"
            onChange={(e) => {
              const newValueRaw = e.target.value;
              const newValueNumber = Number(newValueRaw);
              submit({
                id,
                key,
                value: newValueNumber,
              });
            }}
          />
          {key === "mechanismRateElite" &&
            (code === "CVKD") && (
              <Text
                position={"absolute"}
                top={"112%"}
                left={"0px"}
                color={"var(--color-secondary)"}
                fontSize={"14px"}
                fontWeight={400}
                minW={"140px"}
              >
                (Yêu cầu nhập phần này)
              </Text>
            )}
             {key === "mechanismRateElite" &&
            (code === "CHUNG") && (
              <Text
                position={"absolute"}
                top={"112%"}
                left={"0px"}
                color={"var(--color-secondary)"}
                fontSize={"14px"}
                fontWeight={400}
                minW={"140px"}
              >
                (Yêu cầu nhập phần này bao gồm VAT)
              </Text>
            )}
        </Box>
      );
    case "rateElite":
      return (
        <Input
          step={"any"}
          type="number"
          value={Number(value)}
          placeholder="Nhập số"
          // w={"150px"}
          onChange={(e) => {
            const newValueRaw = e.target.value;
            const newValueNumber = Number(newValueRaw);
            submit({
              id,
              key,
              value: newValueNumber,
            });
          }}
        />
      );

    case "commissionPrice":
      if (statusData) {
        return (
          <Text lineHeight={"28px"} cursor={"pointer"} fontWeight={"500"}>
            {value ? `${formatNumber(value)} VNĐ` : "0 VNĐ"}
          </Text>
        );
      } else {
        return <Text>{value}</Text>;
      }

    case "code":
      let content;
      if (value === "TOTAL" || value === "REMAIN") {
        content = <Flex gap={4} w={"max-content"}></Flex>;
      } else {
        content = <Text>{value}</Text>;
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    default:
      return <Text>{value}</Text>;
  }
};
